import {useState} from "react"
import { faStream, faTv, faLightbulb, faPlug, faGamepad, faGlasses, faPhone} from '@fortawesome/free-solid-svg-icons'
import { faPlaystation, faXbox, faAmazon, faApple, faGoogle } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
const BrandImages = {
  "Oculus": faGlasses,
  "Nintendo": faGamepad,
  'Sony': faPlaystation,
  'Microsoft': faXbox,
  'Google': faGoogle,
  'tv':faTv,
  'Roku': faStream,
  'Amazon': faAmazon,
  'Apple': faApple,
  'Merkury': faLightbulb,
  'Wemo': faLightbulb,
  'Lumiman': faLightbulb,
  'LuvLink': faLightbulb,
  'TP-Link': faPlug,
  'Gosund': faLightbulb,
  'Samsung': faPhone,
  'OnePlus': faPhone,
}
export default function CreateList({brand, data, moreInfoSetData}){
    const [displayList, updateListDisplay] = useState("none");
    const svg = (<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-info-circle" viewBox="0 0 16 16">
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
    </svg>);
    const listData = Object.keys(data).map((element, index) => {
        let spanColor = "";
        let item = data[element];
        switch (item["Status"]){
        case "Obsolete":
            spanColor = "gray";
            break;
        case "Verified":
            spanColor = "green";
            break;
        case "Supported by OIT":
            spanColor = "green";
            break;
        case "verified":
            spanColor = "green";
            break;
        case "Problems":
            spanColor = "orange";
            break;
        case "Xfinity compatible. Poor performance in tests.":
            spanColor = "orange";
            break;
        case "Issue with Compatibility (outdated wireless technology)":
            spanColor = "orange";
            break;
        case "Compatible (not recommended for live tv streaming)":
            spanColor = "orange";
            break;
        case "Issue with Compatibility (poor wireless connection)":
            spanColor = "orange";
            break;
        case "Potential compatibility issues (only 2.4GHz)":
            spanColor = "orange";
            break;
        case "Potential compatibility issues (outdated wireless technology)":
            spanColor = "orange";
            break;
        case "Potential compatibility issue: (poor wireless connection)":
            spanColor = "orange";
            break;
        case "Unverified":
            spanColor = "teal";
            break;
        case "Untested":
            spanColor = "teal";
            break;
        case "Not Allowed":
            spanColor = "red";
            break;
        default:
            spanColor = "red"
        }
        return (<li className='chargerWifi-deviceList-ListItems-li' key={index}>
                <h5>{item["Device Model/Series"]}<span onClick={()=>{moreInfoSetData(item)}} style={{marginLeft:2, cursor:"pointer"}}>{svg}</span></h5>
                <span className="chargerWifi-deviceList-span" style={{backgroundColor:spanColor}}>{item["Status"]}</span>
                </li>)
    })
    return(
        <li  className='chargerWifi-deviceList-listsInnerContainer-li'>
        <button onClick={()=>{
            if(displayList === "none"){
            updateListDisplay("flex")
            } else {
            updateListDisplay("none")
            }
        }}>
        <h4>
            {BrandImages[brand] ? <FontAwesomeIcon icon={BrandImages[brand]}/> : <FontAwesomeIcon icon={BrandImages["tv"]}/> }
            {brand}</h4><span>{'>'}</span></button>
        <ul className="chargerWifi-deviceList-ListItems" style={{display:displayList}}>
            {listData}
        </ul>
        </li>
    )
}